module.exports = __webpack_public_path__ + "img/sjyy-cwhd-part-two.306a1e30.png";